module.exports = __webpack_public_path__ + "img/icon-customer-database.1ea9aed6.png";